<script setup>
import {onClickOutside} from '@vueuse/core';
import {ref, watch} from 'vue';
import FadeTransition from '@/components/transitions/FadeTransition.vue';

const props = defineProps({
  position: {
    type: String,
    default: 'tw-top-16 -tw-right-px',
  },
  dropdownOpen: {
    type: Boolean,
    default: false,
  },
  disableClickOutside: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:dropdownOpen']);
const dropdown = ref(null);
const showDropdown = ref(props.dropdownOpen);

// Watch for external changes to dropdownOpen prop
watch(() => props.dropdownOpen, (newValue) => {
  showDropdown.value = newValue;
});

const toggleDropdown = () => {
  showDropdown.value = !showDropdown.value;
  emit('update:dropdownOpen', showDropdown.value);
};

onClickOutside(dropdown, () => !props.disableClickOutside && showDropdown.value === true && toggleDropdown());
</script>

<template>
  <div
    ref="dropdown"
    class="tw-relative"
  >
    <slot
      name="trigger"
      :toggle-dropdown="toggleDropdown"
    />

    <FadeTransition>
      <div
        v-if="showDropdown"
        :class="`tw-absolute tw-bg-white tw-border tw-border-neutral-300 tw-rounded-lg tw-flex tw-flex-col tw-gap-2 tw-z-50 tw-p-4 ${position}`"
      >
        <slot name="content" />
      </div>
    </FadeTransition>
  </div>
</template>
